{
  "name": "line-helper",
  "version": "0.1.11",
  "description": "LINE Helper CLI - A CLI tool for LINE Front-end Framework (LIFF) and Messaging API development",
  "publishConfig": {
    "access": "public"
  },
  "license": "MIT",
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "typecheck": "tsc --noEmit",
    "clean": "rimraf dist",
    "start": "node dist/index.js",
    "format:write": "prettier --write \"**/*.{ts,tsx,mdx}\" --cache",
    "format:check": "prettier --check \"**/*.{ts,tsx,mdx}\" --cache",
    "pub:next": "pnpm build && pnpm publish --no-git-checks --access public --tag next",
    "pub:release": "pnpm build && pnpm publish --no-git-checks --access public"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/iamprompt/line-helper-cli.git"
  },
  "keywords": [
    "LINE",
    "LINE Login",
    "LINE Front-end Framework",
    "LIFF",
    "LINE Messaging API",
    "LINE Bot",
    "LINE Developers",
    "LINE Developers Thailand"
  ],
  "files": [
    "dist"
  ],
  "type": "module",
  "exports": "./dist/index.js",
  "bin": "./dist/index.js",
  "author": "",
  "dependencies": {
    "axios": "^1.5.1",
    "chalk": "^5.3.0",
    "commander": "^11.0.0",
    "cosmiconfig": "^8.3.6",
    "fs-extra": "^11.1.1",
    "prompts": "^2.4.2",
    "zod": "^3.22.2"
  },
  "devDependencies": {
    "@types/fs-extra": "^11.0.2",
    "@types/prompts": "^2.4.5",
    "@typescript-eslint/parser": "^6.7.3",
    "eslint": "^8.50.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-plugin-import": "^2.28.1",
    "eslint-plugin-prettier": "^5.0.0",
    "eslint-plugin-simple-import-sort": "^10.0.0",
    "eslint-plugin-unused-imports": "^3.0.0",
    "prettier": "^3.0.3",
    "rimraf": "^5.0.5",
    "tsup": "^7.2.0",
    "type-fest": "^4.3.2",
    "typescript": "^5.2.2"
  }
}
